import React from 'react';
import styled from 'styled-components';

const RootContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`;

const BackgroundContainer = styled.div`
  width: 100%;
  position: relative;
  top: 32px;
  z-index: 1;
`;

const Background = ({ themeColor }: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1873.5 1393.1">
    <defs>
      <clipPath id="j">
        <path d="M1448.7 714.88h-211.92v7.697h211.92z" />
      </clipPath>
      <linearGradient
        id="b"
        x2="1"
        gradientTransform="matrix(211.91 0 0 -211.91 1236.8 718.72)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.427" stopColor="#c7c7c7" />
        <stop offset="0.546" stopColor="#c7c7c7" />
        <stop offset="0.937" stopColor="#515050" />
        <stop offset="1" stopColor="#515050" />
      </linearGradient>
      <clipPath id="i">
        <path d="M1448.7 277.92h-211.92v7.696h211.92z" />
      </clipPath>
      <linearGradient
        id="a"
        x2="1"
        gradientTransform="matrix(211.91 0 0 -211.91 1236.8 281.77)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.427" stopColor="#c7c7c7" />
        <stop offset="0.546" stopColor="#c7c7c7" />
        <stop offset="0.937" stopColor="#515050" />
        <stop offset="1" stopColor="#515050" />
      </linearGradient>
      <clipPath id="h">
        <path d="M186.96 550.77H98.208l-5.535 98.901h98.9z" />
      </clipPath>
      <linearGradient
        id="g"
        x2="1"
        gradientTransform="matrix(0 98.9 98.9 0 142.12 550.77)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="n">
        <path d="M186.96 480.11H98.208l-5.535 98.901h98.9z" />
      </clipPath>
      <linearGradient
        id="f"
        x2="1"
        gradientTransform="matrix(0 98.9 98.9 0 142.12 480.11)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="m">
        <path d="M186.96 411.33H98.208l-5.535 98.9h98.9z" />
      </clipPath>
      <linearGradient
        id="e"
        x2="1"
        gradientTransform="matrix(0 98.9 98.9 0 142.12 411.33)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="l">
        <path d="M186.96 340.89H98.208l-5.535 98.899h98.9z" />
      </clipPath>
      <linearGradient
        id="d"
        x2="1"
        gradientTransform="matrix(0 98.9 98.9 0 142.12 340.89)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="k">
        <path d="M925.63 720.96H547.75v212.56h377.88z" />
      </clipPath>
      <linearGradient
        id="c"
        x2="1"
        gradientTransform="scale(378.6 -378.6) rotate(33.01 4.888 1.417)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.036" stopColor="#282827" />
        <stop offset="0.154" stopColor="#797979" />
        <stop offset="0.165" stopColor="#797979" />
        <stop offset="0.291" stopColor="#c7c7c7" />
        <stop offset="0.412" stopColor="#797979" />
        <stop offset="0.552" stopColor="#282827" />
        <stop offset="0.634" stopColor="#282827" />
        <stop offset="0.754" stopColor="#282827" />
        <stop offset="0.863" stopColor="#b3b3b4" />
        <stop offset="0.972" stopColor="#646565" />
        <stop offset="1" stopColor="#646565" />
      </linearGradient>
    </defs>
    <path
      fill="#e5e4e3"
      d="M0 0h-487.63l-247.02-336H245.6z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9) translate(980.34 595.96)"
    />
    <path
      fill="#d8d7d6"
      d="M1225.6 229.35H246.06v30.61h979.54z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9)"
    />
    <path
      fill={themeColor || '#6e971e'}
      d="M1442.8 284.88h-200v430h200z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9)"
    />
    <g
      clipPath="url(#j)"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9)"
    >
      <path fill="url(#b)" d="M1448.7 714.88h-211.92v7.697h211.92z" />
    </g>
    <path
      fill="#282827"
      d="M1237.2 711.18h-3.83v15.096h3.83z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9)"
    />
    <path
      fill="#515050"
      d="M1452.6 711.18h-3.829v15.096h3.829z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9)"
    />
    <g
      clipPath="url(#i)"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9)"
    >
      <path fill="url(#a)" d="M1448.7 277.92h-211.92v7.696h211.92z" />
    </g>
    <path
      fill="#282827"
      d="M1237.2 274.23h-3.83v15.096h3.83z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9)"
    />
    <path
      fill="#515050"
      d="M1452.6 274.23h-3.829v15.096h3.829z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9)"
    />
    <path
      fill="#404041"
      d="M0 0h-158.63l14.76 378.74h130.96z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9) translate(221.71 285.41)"
    />
    <path
      fill="#bbbdbf"
      d="M0 0h-111.58l-9.226 378.74h130.96z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9) translate(198.64 285.41)"
    />
    <g
      clipPath="url(#h)"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9)"
    >
      <path
        fill="url(#g)"
        d="M186.96 550.77H98.208l-5.535 98.901h98.9z"
      />
    </g>
    <g
      clipPath="url(#n)"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9)"
    >
      <path
        fill="url(#f)"
        d="M186.96 480.11H98.208l-5.535 98.901h98.9z"
      />
    </g>
    <g
      clipPath="url(#m)"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9)"
    >
      <path fill="url(#e)" d="M186.96 411.33H98.208l-5.535 98.9h98.9z" />
    </g>
    <g
      clipPath="url(#l)"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9)"
    >
      <path
        fill="url(#d)"
        d="M186.96 340.89H98.208l-5.535 98.899h98.9z"
      />
    </g>
    <path
      fill="#404041"
      d="M236.81 278.23H47.44v14.367h189.37z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9)"
    />
    <path
      fill="#f0f0f0"
      d="M1051.8 1182.6h-632v-687h632z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9)"
    />
    <path
      fill={themeColor || '#6e971e'}
      d="M0 0h-938l-20 104H20z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9) translate(1205.8 1078.6)"
    />
    <path
      fill={themeColor || '#6d8e1b'}
      d="M0 0h-632l-152 78h938z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9) translate(1051.8 1000.6)"
    />
    <path
      fill="#c4c6c4"
      d="M0 0h-45l-61-800h45z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9) translate(371.81 1064.6)"
    />
    <path
      fill="#b2b2b2"
      d="M0 0l23 30 53 733 69-37v24l-84 50z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9) translate(310.81 264.64)"
    />
    <path
      fill="#a0a0a0"
      d="M0 0h-25l-45.192 20.513L-69 37z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9) translate(455.81 990.64)"
    />
    <path
      fill={themeColor || '#6e971e'}
      d="M0 0h23l58 784H61z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9) translate(276.81 272.64)"
    />
    <path
      fill="#c4c6c4"
      d="M0 0h45l61-800H61z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9) translate(1099.8 1064.6)"
    />
    <path
      fill="#b2b2b2"
      d="M0 0l-23 30-53 733-69-37v24l84 50z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9) translate(1160.8 264.64)"
    />
    <path
      fill="#a0a0a0"
      d="M0 0h25l45.192 20.513L69 37z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9) translate(1015.8 990.64)"
    />
    <path
      fill={themeColor || '#6e971e'}
      d="M0 0h-23l-58 784h20z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9) translate(1194.8 272.64)"
    />
    <path
      fill="#d8d7d6"
      d="M872.5 305.42H612.86v259.64H872.5z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9)"
    />
    <path
      fill="#e5e4e3"
      d="M0 0h-234.83l-12.403-19.019h259.64z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9) translate(860.1 584.08)"
    />
    <path
      fill={themeColor || '#7a9b2a'}
      d="M0 0v165.08l8.233 18.988h145.27l10.688-18.988V0z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9) translate(660.59 404.45)"
    />
    <path
      fill={themeColor || '#6e971e'}
      d="M824.78 402.67H660.59v166.85h164.19z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9)"
    />
    <g
      clipPath="url(#k)"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9)"
    >
      <path fill="url(#c)" d="M925.63 720.96H547.75v212.56h377.88z" />
    </g>
    <path
      fill="none"
      stroke="#59595c"
      strokeMiterlimit="10"
      strokeWidth="7"
      d="M925.63 720.96H547.75v212.56h377.88z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9)"
    />
    <path
      fill="#fff"
      stroke={themeColor || '#637c14'}
      strokeMiterlimit="10"
      strokeWidth="7"
      d="M1027.7 1057.1H443.96v213.56h583.74z"
      transform="matrix(1.3333 0 0 -1.3333 -63.249 1698.9)"
    />
  </svg>
);

export interface BoothBackgroundProps {
  themeColor?: string;
}

const BoothBackground: React.FC<BoothBackgroundProps> = ({ themeColor }: BoothBackgroundProps) => (
  <RootContainer>
    <BackgroundContainer>
      <Background themeColor={themeColor} />
    </BackgroundContainer>
  </RootContainer>
);

export default BoothBackground;
